import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Tooltip,
  Box,
  useMediaQuery,
  Card,
  CardContent,
  Stack,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import FuseLoading from "@fuse/core/FuseLoading";
import { useSelector, useDispatch } from "react-redux";
import { useDeepCompareEffect } from "@fuse/hooks";
import { getLocalsAdmin, selectLocal } from "../store/localAdminSlice";
import LocalModal from "./LocalModal";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import StorefrontIcon from "@mui/icons-material/Storefront";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${TableCell.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 600,
    fontSize: 14,
  },
  [`&.${TableCell.body}`]: {
    fontSize: 14,
  },
}));

export default function LocalTable() {
  const dispatch = useDispatch();
  const locals = useSelector(selectLocal);
  const [openModal, setOpenModal] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useDeepCompareEffect(() => {
    dispatch(getLocalsAdmin());
  }, [dispatch]);

  if (!locals) return <FuseLoading />;

  const handleAddLocal = () => setOpenModal(true);

  return (
    <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          gap: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <StorefrontIcon color="primary" fontSize="large" />
          <Typography variant="h6" fontWeight={600}>
            Gestión de Locales
          </Typography>
        </Stack>

        <LocalModal/>
      </Box>

      {/* Tabla o Cards según dispositivo */}
      {isMobile ? (
        <Stack spacing={2}>
          {locals.length === 0 ? (
            <Typography variant="body2" textAlign="center" color="text.secondary">
              No hay locales registrados
            </Typography>
          ) : (
            locals.map((local) => (
              <Card key={local.id} variant="outlined">
                <CardContent>
                  <Stack spacing={0.5}>
                    <Typography fontWeight={600}>{local.fantasy_name}</Typography>
                    <Typography color="text.secondary">
                      {local.premium ? "Premium" : "Basic"}
                    </Typography>
                    <Typography color="text.secondary">{local.address}</Typography>
                    <Typography color="text.secondary">{local.company_name}</Typography>
                    <Typography color="text.secondary">{local.emp_admin.name}</Typography>
                    <Typography color="text.secondary">{local.rut}</Typography>
                    <Typography color="text.secondary">{local.num_auth_sani}</Typography>
                  </Stack>
                  {/* <Box mt={1} display="flex" justifyContent="flex-end">
                    <LocalModal isEdit localId={local.id} />
                  </Box> */}
                </CardContent>
              </Card>
            ))
          )}
        </Stack>
      ) : (
        <TableContainer>
          <Table size="medium" aria-label="tabla de locales">
            <TableHead>
              <TableRow>
                <StyledTableCell>Nombre de fantasía</StyledTableCell>
                <StyledTableCell>Plan</StyledTableCell>
                <StyledTableCell>Sucursal</StyledTableCell>
                <StyledTableCell>Nombre compañía</StyledTableCell>
                <StyledTableCell>Empresa administradora</StyledTableCell>
                <StyledTableCell>RUT</StyledTableCell>
                <StyledTableCell>N° Autorización Sanitaria</StyledTableCell>
                <StyledTableCell align="right">Acciones</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {locals.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Typography variant="body2" color="text.secondary">
                      No hay locales registrados
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                locals.map((local) => (
                  <TableRow
                    key={local.id}
                    hover
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      transition: "background-color 0.2s",
                      "&:hover": { backgroundColor: theme.palette.action.hover },
                    }}
                  >
                    <TableCell>{local.fantasy_name}</TableCell>
                    <TableCell>{local.premium ? "Premium" : "Basic"}</TableCell>
                    <TableCell>{local.address}</TableCell>
                    <TableCell>{local.company_name}</TableCell>
                    <TableCell>{local.emp_admin.name}</TableCell>
                    <TableCell>{local.rut}</TableCell>
                    <TableCell>{local.num_auth_sani}</TableCell>
                    <TableCell align="right">
                      <LocalModal isEdit localId={local.id} />
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Modal para crear local */}
      {/* <LocalModal open={openModal} onClose={() => setOpenModal(false)} /> */}
    </Paper>
  );
}
